import { readStored, removeStored, writeStored } from '../storage';
import type { Audience } from './roles';

export interface SessionUser {
  id: string;
  fullName: string;
  phoneNumber: string;
  email?: string;
  role: string;
}

export interface Session {
  accessToken: string;
  user: SessionUser;
  audience: Audience;
}

const SESSION_KEY = 'tcm.session.v1';

function isSession(value: unknown): value is Session {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const candidate = value as Partial<Session>;
  return (
    typeof candidate.accessToken === 'string' &&
    typeof candidate.audience === 'string' &&
    !!candidate.user &&
    typeof candidate.user.id === 'string' &&
    typeof candidate.user.role === 'string'
  );
}

export function loadSession(): Session | null {
  const stored = readStored<unknown>(SESSION_KEY, null);
  return isSession(stored) ? stored : null;
}

export function saveSession(session: Session): void {
  writeStored(SESSION_KEY, session);
}

export function clearSession(): void {
  removeStored(SESSION_KEY);
}
